import { Component } from 'san';

export default class LeanInputCell extends Component {
    static computed = {
        isFocus(): boolean {
            const focusId = this.data.get('focusId');
            const id = this.data.get('id');
            return focusId === id;
        }
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        focusId: string;    // {{}}
        id: string; // {{}}
        isRequired: boolean;    // {{}}
        isEmpty: boolean;   // {{}} 值为空
        isShowIcon: boolean;  // {{}} 显示图标
        title: string;  // {{}}
        description: string;    //{{}}
        autoFocusToInner: boolean; // {{}} 自动获取焦点（被点击元素，自动 focus 到内部首个 input、textarea、select 元素上）
        iconLocation: 'center-middle' | 'right-bottom'; // 图标位置（默认居中）
        disabled: boolean;  // {{}}
    } {
        return {
            focusId: null,
            id: null,
            isRequired: false,
            isEmpty: true,
            isShowIcon: false,
            title: '',
            description: '',
            autoFocusToInner: true,
            iconLocation: 'center-middle',
            disabled: false,
        };
    }

    inited(): void {
        this.watch('isFocus', isFocus => {
            if (isFocus) {
                this.onFocus();
            } else {
                this.onBlur();
            }
        });
    }

    onFocus() {
        if (this.data.get('disabled')) {
            return;
        }

        this.fire('focus', this.data.get('id'));

        if (!this.data.get('autoFocusToInner')) {
            return;
        }

        const el = $(this.el);
        const inputEle = el.find('input');
        if (inputEle[0]) {
            inputEle.focus();
            return;
        }
        const textareaEle = el.find('textarea');
        if (textareaEle[0]) {
            textareaEle.focus();
            return;
        }
        const selectEle = el.find('select');
        if (selectEle[0]) {
            selectEle.focus();
            return;
        }
    }

    onBlur() {
        this.fire('blur', this.data.get('id'));
    }

    onClick() {
        if (this.data.get('disabled')) {
            return;
        }
        this.fire('click', this.data.get('id'));
        this.onFocus();
    }

    onIconClick() {
        if (this.data.get('disabled')) {
            return;
        }
        this.fire('icon-click', this.data.get('id'));
    }
}
